import { ReactNode } from 'react';

type RectangleInfoCardProps = {
  title: string
  subtitle: string | ReactNode
  iconSrc: string
}

export const RectangleInfoCard = ({ title, subtitle, iconSrc }: RectangleInfoCardProps) => {
  return (
    <div className="flex min-h-[90px] items-start gap-4 rounded-2xl bg-white p-6 shadow-[0_4px_12px_rgba(0,0,0,0.08)] md:px-8">
      <div className="flex shrink-0 items-center">
        <img src={iconSrc} alt="" width={48} height={48} />
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="mb-4 text-sm font-bold text-primary2">{title}</h4>
        <div className="flex flex-wrap items-center gap-2">
          {
            typeof subtitle === 'string'
              ? <span>{subtitle}</span>
              : subtitle
          }
        </div>
      </div>
    </div>
  )
}
